module.exports = __webpack_public_path__ + "static/media/jason.7d438777.png";